import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../context/LanguageContext';
import './CompanyManagement.css';

function CompanyManagement() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [companies, setCompanies] = useState([
    {
      id: 1,
      name: 'aaa',
      code: 'aaa',
      ceo: '김대표',
      businessNumber: '124-81-00998',
      address: '서울특별시 영등포구',
      phone: '031-200-1114',
      employees: 120,
      statusKey: 'active',
      createdDate: '2020-01-15'
    },
  ]);

  const [searchQuery, setSearchQuery] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [companyToDelete, setCompanyToDelete] = useState(null);

  const handleAddCompany = () => {
    navigate('/admin/company/register');
  };

  const handleRowClick = (companyId) => {
    navigate(`/admin/company/${companyId}`);
  };

  const handleEditClick = (companyId) => {
    navigate(`/admin/company/${companyId}?edit=true`);
  };

  const handleDeleteClick = (company) => {
    setCompanyToDelete(company);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = () => {
    if (companyToDelete) {
      setCompanies(companies.filter(c => c.id !== companyToDelete.id));
      setShowDeleteModal(false);
      setCompanyToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setCompanyToDelete(null);
  };

  const getStatusClass = (statusKey) => {
    return statusKey === 'active' ? 'status-active' : 'status-inactive';
  };

  const filteredCompanies = companies.filter(company => {
    const matchesSearch = company.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         company.code.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = selectedStatus === 'all' || company.statusKey === selectedStatus;
    return matchesSearch && matchesStatus;
  });

  return (
    <div className="company-management-container">
      {/* 필터 및 검색 */}
      <div className="company-controls">
        <div className="control-left">
          <label className="control-label">{t('pages.admin.companyManagement.statusLabel')}</label>
          <div className="dropdown-container">
            <select
              className="status-dropdown"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="all">{t('pages.admin.companyManagement.statusAll')}</option>
              <option value="active">{t('pages.admin.companyManagement.statusActive')}</option>
              <option value="inactive">{t('pages.admin.companyManagement.statusInactive')}</option>
            </select>
            <svg className="dropdown-icon" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>

        <div className="control-right">
          <div className="search-container">
            <input
              type="text"
              className="search-input"
              placeholder={t('pages.admin.companyManagement.searchPlaceholder')}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <svg className="search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M14 14L11.1 11.1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <button className="add-company-btn" onClick={handleAddCompany}>
            <svg className="plus-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 3V13M3 8H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            {t('pages.admin.companyManagement.addBtn')}
          </button>
        </div>
      </div>

      {/* 회사 목록 테이블 */}
      <div className="company-table-container">
        <table className="company-table">
          <thead>
            <tr>
              <th>{t('pages.admin.companyManagement.col.name')}</th>
              <th>{t('pages.admin.companyManagement.col.code')}</th>
              <th>{t('pages.admin.companyManagement.col.ceo')}</th>
              <th>{t('pages.admin.companyManagement.col.businessNumber')}</th>
              <th>{t('pages.admin.companyManagement.col.address')}</th>
              <th>{t('pages.admin.companyManagement.col.phone')}</th>
              <th>{t('pages.admin.companyManagement.col.employees')}</th>
              <th>{t('pages.admin.companyManagement.col.status')}</th>
              <th>{t('pages.admin.companyManagement.col.createdDate')}</th>
              <th>{t('pages.admin.companyManagement.col.action')}</th>
            </tr>
          </thead>
          <tbody>
            {filteredCompanies.map((company) => (
              <tr key={company.id} onClick={() => handleRowClick(company.id)} className="clickable-row">
                <td className="company-name-cell">
                  <div className="company-name">{company.name}</div>
                </td>
                <td>{company.code}</td>
                <td>{company.ceo}</td>
                <td>{company.businessNumber}</td>
                <td className="address-cell">{company.address}</td>
                <td>{company.phone}</td>
                <td>{t('pages.admin.companyManagement.employeesSuffix', { n: company.employees.toLocaleString() })}</td>
                <td>
                  <span className={`status-badge ${getStatusClass(company.statusKey)}`}>
                    {company.statusKey === 'active'
                      ? t('pages.admin.companyManagement.statusActive')
                      : t('pages.admin.companyManagement.statusInactive')}
                  </span>
                </td>
                <td>{company.createdDate}</td>
                <td onClick={(e) => e.stopPropagation()}>
                  <div className="action-buttons">
                    <button className="action-btn edit-btn" onClick={() => handleEditClick(company.id)}>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M11.3333 2C11.5084 1.82493 11.7163 1.68605 11.9457 1.59135C12.1752 1.49665 12.4218 1.44803 12.6707 1.44803C12.9196 1.44803 13.1662 1.49665 13.3956 1.59135C13.6251 1.68605 13.833 1.82493 14.008 2C14.183 2.17507 14.3219 2.38299 14.4166 2.61245C14.5113 2.84191 14.5599 3.08852 14.5599 3.33744C14.5599 3.58636 14.5113 3.83297 14.4166 4.06243C14.3219 4.29189 14.183 4.49981 14.008 4.67488L5.33333 13.3495L1.33333 14.683L2.66667 10.6829L11.3333 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <button className="action-btn delete-btn" onClick={(e) => { e.stopPropagation(); handleDeleteClick(company); }}>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M2 4H3.33333H14M5.33333 4V2.66667C5.33333 2.31305 5.47381 1.97391 5.72386 1.72386C5.97391 1.47381 6.31305 1.33333 6.66667 1.33333H9.33333C9.68696 1.33333 10.0261 1.47381 10.2761 1.72386C10.5262 1.97391 10.6667 2.31305 10.6667 2.66667V4M6.66667 7.33333V11.3333M9.33333 7.33333V11.3333M3.33333 4V13.3333C3.33333 13.687 3.47381 14.0261 3.72386 14.2761C3.97391 14.5262 4.31305 14.6667 4.66667 14.6667H11.3333C11.687 14.6667 12.0261 14.5262 12.2761 14.2761C12.5262 14.0261 12.6667 13.687 12.6667 13.3333V4H3.33333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 통계 */}
      <div className="company-stats">
        <div className="stat-card">
          <div className="stat-label">{t('pages.admin.companyManagement.stats.total')}</div>
          <div className="stat-value">{companies.length}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">{t('pages.admin.companyManagement.stats.active')}</div>
          <div className="stat-value stat-active">{companies.filter(c => c.statusKey === 'active').length}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">{t('pages.admin.companyManagement.stats.inactive')}</div>
          <div className="stat-value stat-inactive">{companies.filter(c => c.statusKey === 'inactive').length}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">{t('pages.admin.companyManagement.stats.employees')}</div>
          <div className="stat-value">{t('pages.admin.companyManagement.employeesSuffix', { n: companies.reduce((sum, c) => sum + c.employees, 0).toLocaleString() })}</div>
        </div>
      </div>

      {/* 삭제 확인 모달 */}
      {showDeleteModal && (
        <div className="modal-overlay" onClick={handleDeleteCancel}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">{t('pages.admin.companyManagement.deleteModal.title')}</h3>
              <button className="modal-close-btn" onClick={handleDeleteCancel}>
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="warning-icon">
                <span className="material-symbols-outlined">warning</span>
              </div>
              <p className="modal-message">
                <strong>{companyToDelete?.name}</strong> {t('pages.admin.companyManagement.deleteModal.messagePrefix')}
              </p>
              <p className="modal-submessage">
                {t('pages.admin.companyManagement.deleteModal.submessage')}
              </p>
            </div>
            <div className="modal-footer">
              <button className="modal-btn cancel-btn" onClick={handleDeleteCancel}>
                {t('pages.admin.companyManagement.deleteModal.cancel')}
              </button>
              <button className="modal-btn delete-confirm-btn" onClick={handleDeleteConfirm}>
                {t('pages.admin.companyManagement.deleteModal.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CompanyManagement;
